export const INVITE_ROLE_HINT =
  'The invitation only adds the person to this tenant. They also need a Datahub role (user or admin) assigned in UDB.';
